import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { uiActions } from '.';
import { VendorsService } from '../../services/vendors.service';
import { of } from 'rxjs';
import { ApiError } from '../../models/common/api-error';
import { storeUiKey } from '../reducers';
import { UiState } from './ui.state';

@Injectable({
  providedIn: 'root',
})
export class UiEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private vendorsService: VendorsService,
  ) {}

  findOne$ = createEffect(() =>
    this.actions$.pipe(
      ofType(uiActions.setVendorSlug),
      withLatestFrom(this.store$),
      // Déduplication : si le vendor demandé est déjà chargé, on ne refait pas l'appel
      filter(([action, store]) => {
        const uiState: UiState = store[storeUiKey];
        return action.vendorSlug !== uiState.vendor?.slug;
      }),
      mergeMap(([action, store]) => {
        if (action.vendorSlug) {
          return this.vendorsService.findOne(action.vendorSlug).pipe(
            map((response) => uiActions.setVendor({ vendor: response })),
            catchError((error) =>
              of(uiActions.setVendorError({ exception: error as ApiError })),
            ),
          );
        } else {
          return of(uiActions.setVendor({ vendor: null }));
        }
      }),
    ),
  );
}
